import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vesper/code/resume-plus/apps/next/components/blog-post.tsx");
